import { ButtressDbService, buttressDbServiceContext } from '@buttress/crag';
import { LtnAuthService } from '../ltn-auth/ltn-auth-service.js';
import { LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { consume } from '@lit/context';
import { nsSettingsServiceContext, ltnAuthServiceContext, nsDirectoryServiceContext } from './contexts.js';

import { NSSettingsService } from '../ns-settings/ns-settings-service.js';
import { NSDirectoryService } from './ns-directory-service.js';

export interface menuItem {
  title: string;
  icon: string;
  link: string;
}

@customElement('ns-email-service')
export class NSEmailService extends LitElement {
  @consume({ context: ltnAuthServiceContext })
  private __auth?: LtnAuthService;
  @consume({ context: buttressDbServiceContext })
  private __db?: ButtressDbService;
  @consume({ context: nsSettingsServiceContext })
  private __settings?: NSSettingsService;
  @consume({ context: nsDirectoryServiceContext })
  private __dir?: NSDirectoryService;

  async connectedCallback() {
    super.connectedCallback();
    await this.updateComplete;

    if (!this.__db) throw new Error('A DB Service Is Required!');

    if (!this.__settings) throw new Error('Unable to find settings service');

    if (!this.__auth) throw new Error('Auth service is required!');

    if (!this.__dir) throw new Error('Directory service not found');
    await this.__dir.initialised;
  }
}
